import IconBool from "components/IconBool";

const TableMQConfigAlerts = ({item, _TC}) => {
    return (
        <>
            <div className="d-inline-block text-center ps-2 pe-3 border-end">
                <div className="fw-medium">{_TC("dist")}</div>
                <div>
                    <IconBool value={item.has.dist} /> <span className="ms-2">{item.values.dist}</span>
                </div>
            </div>
            <div className="d-inline-block text-center ps-2 pe-3 border-end">
                <div className="fw-medium">{_TC("sacc")}</div>
                <div>
                    <IconBool value={item.has.sacc} /> <span className="ms-2">{item.values.sacc}</span>
                </div>
            </div>
            <div className="d-inline-block text-center ps-2 pe-3 border-end">
                <div className="fw-medium">{_TC("temp")}</div>
                <div>
                    <IconBool value={item.has.temp} /> <span className="ms-2">{item.values.temp}</span>
                </div>
            </div>
            <div className="d-inline-block text-center ps-2 pe-3 border-end">
                <div className="fw-medium">{_TC("bat")}</div>
                <div>
                    <IconBool value={item.has.bat} /> <span className="ms-2">{item.values.bat}</span>
                </div>
            </div>
            <div className="d-inline-block text-center ps-2 pe-3 border-end">
                <div className="fw-medium">{_TC("signal")}</div>
                <div>
                    <IconBool value={item.has.signal} /> <span className="ms-2">{item.values.signal}</span>
                </div>
            </div>
        </>
    );
};

export default TableMQConfigAlerts;
